import * as innovationByDesignPageActions from '../../action_creators/ibd/innovation_by_design_page_action_creators';
import log from '../../../services/logger_service';
import asyncFranchiseActions from '../franchise/franchise_page_actions';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import asyncInnovationByDesignActions from './async_innovation_by_design_actions';
import asyncInnovationByDesignAllFeedActions from './async_innovation_by_design_all_feed_actions';
import asyncInnovationByDesignDetailsActions from './async_innovation_by_design_details_actions';

const LATEST_ACTIVE_YEAR = '2023';

export default function fetchPersonPage(params, store) {
  const { year } = params;

  return function firstDispatch(dispatch) {
    if (!params.category) {
      dispatch(
        innovationByDesignPageActions.innovationByDesignPageLoading({}, store)
      );
    }

    const asyncActions = [
      asyncInnovationByDesignDetailsActions(params, store)(dispatch),
      asyncInnovationByDesignActions(params, store)(dispatch),
      asyncInnovationByDesignAllFeedActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ];
    if (year === 'list') {
      asyncActions.push(
        asyncFranchiseActions({ slug: `ibd-${LATEST_ACTIVE_YEAR}` }, store)(
          dispatch
        )
      );
    }

    if (year === '2022') {
      asyncActions.push(
        asyncFranchiseActions({ slug: 'ibd-2022-2' }, store)(dispatch)
      );
    }

    return Promise.all(asyncActions)
      .then(function handlePostDetailData(resp) {
        dispatch(
          innovationByDesignPageActions.innovationByDesignPageLoaded(
            resp,
            store
          )
        );
        return true;
      })
      .catch(function handleUserError(err) {
        dispatch(
          innovationByDesignPageActions.innovationByDesignPageLoadError(
            err,
            store
          )
        );
        return log.error(
          err,
          `Error in tag page actions, message: ${err.message}`
        );
      });
  };
}
